import { client } from '../lib/client';
import { getVisitorKey } from '../components/chat/visitorKey';

// 실시간문의 — 회원은 토큰, 비회원은 방문객 키(X-Web-Visitor)로 식별한다. 문의(방)는 여러 개일 수 있다. 실시간 수신은 소켓(/web-chat)
const headers = () => ({ 'X-Web-Visitor': getVisitorKey() });

// 내 문의 목록 + 저장된 이름·연락처 + 안읽음 합계
export const chatSessionAPI = () => (
  client({ url: '/v1/chat/session', headers: headers() }, true)
);

// 한 문의의 대화 — before(ISO)로 이전 더 보기
export const chatMessagesAPI = (roomId, before) => (
  client({ url: `/v1/chat/rooms/${roomId}/messages`, params: before ? { before } : undefined, headers: headers() }, true)
);

// 보내기 — roomId 없으면 새 문의. contact: 비회원 첫 메시지에 함께 보내는 이름·연락처(방에 저장, 다음부터 그대로 쓴다)
export const chatSendAPI = ({ roomId, text, page, contact }) => (
  client({
    url: '/v1/chat/send',
    method: 'post',
    data: { ...(roomId ? { roomId } : {}), text, page, ...(contact ? { contact } : {}) },
    headers: headers(),
  }, true)
);

export const chatReadAPI = (roomId) => (
  client({ url: `/v1/chat/rooms/${roomId}/read`, method: 'post', headers: headers() }, true)
);
